module.exports = __webpack_public_path__ + "static/img/blog-2.1ecb962.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog-2.png
// module id = Dy8c
// module chunks = 1